//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 1. 先判断抽奖活动是否进行中，若不存在或过期，显示提示信息
 * 2. 在判断是否已抽奖，若已抽奖直接调整至中奖结果页面
 * 3. 若未抽奖，显示用户类型选择按钮
 */
export default {
  data () {
    return {
      openid: '',
      lotteryProjectCode: '',
      showUserTypeCard: false,
      lotteryProjectConfig: {
        active: true,
        startTime: '',
        endTime: '',
        address: ''
      }
    }
  },
  async created () {
    const p = new URLSearchParams(location.search)
    this.openid = p.get('openid') || ''
    if (this.$Utils.IsEmpty(this.openid)) {
      this.openid = this.$UserUtils.getWxOpenId();
    }
    // 抽奖活动代码
    this.lotteryProjectCode = p.get('lotteryProjectCode') || ''
    if (this.$Utils.IsEmpty(this.lotteryProjectCode)) {
      this.lotteryProjectCode = p.get('state') || ''
    }
    await this.getLotterConfig()
    if (this.lotteryProjectConfig && this.lotteryProjectConfig.active) {
      await this.getLotteryRecord()
    }
  },
  methods: {
    /**
     * 获取抽奖记录
     */
    async getLotteryRecord () {
      let that = this;
      let url = '/lottery/record/getLotteryRecordByOpenId';
      let res = await that.$axios.post(url, null, {params: {openId: that.openid, lotteryProjectCode: that.lotteryProjectCode}});
      if (res.meta.success) {
        // 获取成功
        let record = res.data;
        if (record && record.id) {
          const params = new URLSearchParams({
            name: record.prize_name,
            img: record.prize_image,
            code: record.verify_code,
            status: record.verify_status,
            qrticket: record.verify_code_qr_ticket,
            address: that.lotteryProjectConfig.address,
            iswin: record.is_win,
            lotteryProjectCode: this.lotteryProjectCode,
            id: record.id
          })

          // 跳转领奖页
          that.$router.push('/wx/lottery/result?openid=' + this.openid + '&' + params.toString())
        } else {
          that.showUserTypeCard = true;
        }
      } else {
        that.$Msgbox.alert(res.meta.message)
        that.showUserTypeCard = false;
      }
    },
    /**
     * 获取抽奖活动基本参数信息
     * @returns {Promise<void>}
     */
    async getLotterConfig () {
      let that = this;
      let url = '/lottery/config/getLotteryBaseInfo';
      let res = await that.$axios.post(url, null, {params: {lotteryProjectCode: that.lotteryProjectCode}});
      if (res.meta.success) {
        // 获取成功
        that.lotteryProjectConfig = res.data;
      } else {
        that.lotteryProjectConfig = null;
        that.$Msgbox.alert(res.meta.message)
      }
    },
    go (type) {
      this.$router.push({
        path: '/wx/lottery/info',
        query: {
          openid: this.openid,
          type: type,
          lotteryProjectCode: this.lotteryProjectCode,
          address: this.lotteryProjectConfig.address
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lottery/SelectType.vue